/* IVIDUS cookie banner (snippets/iv-consent.liquid) on Shopify's Customer Privacy API.
   Shows when the API says the visitor's region needs a banner and no choice is stored yet; the choice is saved with
   setTrackingConsent, never on page load. [data-iv-consent-open] (footer) opens the choices again. */
(() => {
  const root = document.getElementById('IvConsent');
  if (!root) return;
  const prefs = root.querySelector('[data-consent-prefs]');
  const manage = root.querySelector('[data-consent="manage"]');
  const status = document.getElementById('IvConsentStatus');
  const KEYS = ['preferences', 'analytics', 'marketing'];
  let opener = null;

  const api = () => window.Shopify && window.Shopify.customerPrivacy;
  const ready = (cb) => {
    if (api() && typeof api().setTrackingConsent === 'function') { cb(); return; }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error && api()) cb();
    });
  };

  const fill = () => {
    const now = typeof api().currentVisitorConsent === 'function' ? api().currentVisitorConsent() : {};
    KEYS.forEach((k) => {
      const input = prefs.querySelector(`[name="${k}"]`);
      if (input) input.checked = now[k] === 'yes';
    });
  };
  const togglePrefs = (open) => {
    if (open) fill();
    prefs.hidden = !open;
    manage.setAttribute('aria-expanded', String(open));
    if (open) prefs.querySelector('input:not([disabled])')?.focus();
  };
  const show = (withPrefs) => {
    root.hidden = false;
    togglePrefs(Boolean(withPrefs));
    requestAnimationFrame(() => root.classList.add('is-open'));
  };
  const hide = () => {
    root.classList.remove('is-open');
    root.hidden = true;
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  };
  const save = (consent) => {
    api().setTrackingConsent(consent, () => {
      if (status) status.textContent = status.dataset.saved || '';
      hide();
    });
  };

  /* Show it wherever Shopify would show its own banner: in the consent regions (shouldShowBanner), and in every
     other region the store's privacy settings show a banner to (Shopify then adds its banner, hidden by our CSS),
     as long as the visitor has not chosen yet. */
  const undecided = () => {
    const now = typeof api().currentVisitorConsent === 'function' ? api().currentVisitorConsent() : {};
    return KEYS.every((k) => !now[k]);
  };
  const whenShopifyBanner = (cb) => {
    if (document.getElementById('shopify-pc__banner')) { cb(); return; }
    const mo = new MutationObserver(() => {
      if (document.getElementById('shopify-pc__banner')) { mo.disconnect(); cb(); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 8000);
  };
  ready(() => {
    if (typeof api().shouldShowBanner === 'function' && api().shouldShowBanner()) { show(false); return; }
    whenShopifyBanner(() => { if (root.hidden && undecided()) show(false); });
  });

  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-consent]');
    if (!b) return;
    const action = b.dataset.consent;
    if (action === 'manage') { togglePrefs(prefs.hidden); return; }
    const all = action === 'accept';
    ready(() => save({ preferences: all, analytics: all, marketing: all }));
  });
  prefs.addEventListener('submit', (e) => {
    e.preventDefault();
    const data = new FormData(prefs);
    ready(() => save({ preferences: data.has('preferences'), analytics: data.has('analytics'), marketing: data.has('marketing') }));
  });
  document.addEventListener('click', (e) => {
    const o = e.target.closest && e.target.closest('[data-iv-consent-open]');
    if (!o) return;
    e.preventDefault();
    opener = o;
    ready(() => show(true));
  });
})();
